import { Outlet, useParams } from "react-router-dom";

import Box from "@mui/material/Box";

import DataHubPageTitle from "../data-hub/components/DataHubPageTitle";

const TelemetryPage = () => {
  const { model } = useParams();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: ".5em",
      }}
    >
      {model && <DataHubPageTitle />}
      <Outlet />
    </Box>
  );
};

export default TelemetryPage;
